import { render, staticRenderFns } from "./AssetChangeListPage.vue?vue&type=template&id=2b08da66&scoped=true"
import script from "./AssetChangeListPage.vue?vue&type=script&lang=js"
export * from "./AssetChangeListPage.vue?vue&type=script&lang=js"
import style0 from "./AssetChangeListPage.vue?vue&type=style&index=0&id=2b08da66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08da66",
  null
  
)

export default component.exports